import * as Sentry from '@sentry/react'
import { createBrowserRouter } from 'react-router-dom'

import { App } from '@/App'
import { RouterErrorBoundary } from '@/shared/components/organisms/ErrorBoundary'

// Create router with Sentry integration
export const router = createBrowserRouter([
	{
		path: '*',
		element: <App />,
		errorElement: <RouterErrorBoundary />,
	},
])

// Wrap the router with Sentry for automatic route tracking
export const sentryCreateBrowserRouter =
	Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)
